import type {
    TAddOrganization, TUpdateOrganization,
} from '@/store/organization/types'
import { runCloudFunction } from '@/store/ParseUtils'
import { resetLoadable } from '@/loadingUtils'
import { instructorModule } from '@/store/instructor/module'
import { organizationModule } from '@/store/organization/module'
import { userModule } from '@/store/user/module'
import * as Sentry from '@sentry/vue'
import { examModule } from '@/store/exam/module'
import { groupModule } from '@/store/group/module'
import { studentModule } from '@/store/student/module'

const addOrganization = async (params: { name: string }) => {
    const newOrg = await runCloudFunction<TAddOrganization>('addOrganization', params)

    resetLoadable(instructorModule.state.currentUserOrgInstructors)

    await instructorModule.actions.fetchCurrentUserOrgInstructors()

    // due to a few fetches that UPDATE_CURRENT_ORGANIZATION triggers, we need to fetch the new orgInstructor
    // record before running it
    await userModule.actions.updateCurrentOrganization(newOrg)

    return newOrg
}

const updateOrganization = async (params: { organizationId: string; name?: string }) => {
    return runCloudFunction<TUpdateOrganization>('updateOrganization', params)
}

const fetchOrganizations = async () => {
    await instructorModule.actions.fetchCurrentUserOrgInstructors()

    return organizationModule.getters.getOrganizations()
}

const fetchCurrentOrganization = async () => {
    await instructorModule.actions.fetchCurrentUserOrgInstructors()

    return organizationModule.getters.getCurrentOrganization()
}

const validateOrgState = () => {
    Promise.all([
        studentModule.actions.validateOrgStudents(),
        examModule.actions.validateOrgExams(),
        groupModule.actions.validateOrgGroups(),
    ]).catch((err: unknown) => {
        // We want to know about org state validation errors, but still try to let user continue
        Sentry.captureException(err)
    })
}

export default {
    addOrganization,
    updateOrganization,
    fetchOrganizations,
    fetchCurrentOrganization,
    validateOrgState,
}
